import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '../../../components';
import useCookie from '../../../helpers/useCookie';

import Button from '../../../components/Button';

import './style.scss';

const MenuFooterItem = ({ title, link, onClick }) => {
  const { t } = useTranslation();

  return (
    <li key={`menu--footer-other--menu-item-${t('cookies.edit')}`} className="menu--footer-other--menu-item">
      <Button
        className="menu-link"
        asLink
        href={link}
        onClick={onClick}
      >
        {title}
      </Button>
    </li>
  );
};

const FooterCopyrightMenu = () => {
  const { t } = useTranslation();
  const { updateConsent } = useCookie();

  return (
    <div className="FooterCopyrightMenu col-sm-12 col-md-6 order-sm-2 order-md-1">
      <Menu id="footer-copyright">
        {(items) => {
          return (
            <div className="FooterCopyrightMenu__items">
              <MenuFooterItem
                title={t('cookies.edit')}
                onClick={updateConsent}
              />

              {items.map((item, index) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url'], '');
                const title = item.getIn(['link', 'title'], 'Untitled');
                return (
                  <li key={`menu--footer-other--menu-item-${title}:${href}`} className="menu--footer-other--menu-item">
                    <CoreLink
                      to={href}
                      target={attrs.get('target')}
                    >
                      {title}
                    </CoreLink>
                  </li>
                );
              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default FooterCopyrightMenu;
